import { createSlice } from "@reduxjs/toolkit";
import { _getTutoringSubjectDetails } from "./tutoringSubjectsAction";

const tutoringSubjectsSlice = createSlice({
  name: "deltaSnp/tutoringSubjects",
  initialState: null,
  reducers: {
    getTutoringSubjectDetails: _getTutoringSubjectDetails,
    resetTutoringSubjectDetails: () => null,
  },
});

export const { getTutoringSubjectDetails, resetTutoringSubjectDetails } =
  tutoringSubjectsSlice.actions;

export default tutoringSubjectsSlice.reducer;
